import React, { useMemo } from 'react';
import { CellProps } from 'react-table';
import moment from 'moment/moment';

import { useI18n } from 'i18n';
import { ITepOfficersNotification } from 'types/tep';

export const useOfficersNotificationsColumns = () => {
  const { fc } = useI18n();

  const getDateCell = ({ cell }: CellProps<ITepOfficersNotification>) => (
    <>{cell.value ? moment(cell.value).format('YYYY-MM-DD, HH:mm:ss') : '-'}</>
  );

  const getContactsCell = ({ cell }: CellProps<ITepOfficersNotification>) => {
    return <div>{cell.value?.join(', ') || '-'}</div>;
  };

  return useMemo(
    () => [
      {
        Header: fc('Contact Number'),
        accessor: 'phoneNumbers',
        Cell: getContactsCell,
        width: 300,
        minWidth: 300,
        isFlexUnset: true,
      },
      { Header: fc('message'), accessor: 'message' },
      { Header: fc('Sent At'), accessor: 'createdAt', Cell: getDateCell, width: 250, minWidth: 250, isFlexUnset: true },
      // {
      //   Header: fc('Delivered At'),
      //   accessor: 'deliveredAt',
      //   width: 230,
      //   minWidth: 230,
      //   isFlexUnset: true,
      //   Cell: getDateCell,
      // },
    ],
    [],
  );
};
